// Fjalori shqip — gjuha bazë. Çdo çelës i ri shtohet së pari këtu,
// pastaj në en.js dhe de.js me të njëjtin emër.
const sq = {
  // Header
  'header.ann.shipping': 'dërgesa të shpejta',
  'header.ann.guarantee': 'garanci 30-ditore',
  'header.about': 'Rreth nesh',
  'header.contact': 'Kontakti',
  'header.search': 'Kërko',
  'header.searchEmpty': 'Nuk u gjet asnjë produkt',
  'header.wishlist': 'Të preferuarat',
  'header.cart': 'Shporta',
  'header.menu': 'Menyja',

  // Footer
  'footer.contact': 'Kontakti',
  'footer.policiesTitle': 'Politikat dhe kushtet e përdorimit',
  'footer.terms': 'Termet dhe Kushtet e Përdorimit',
  'footer.privacy': 'Politika e privatësisë',
  'footer.legal': 'Njoftime ligjore',
  'footer.returns': 'Politika e kthimeve',
  'footer.shippingPolicy': 'Politika e dërgesave',
  'footer.newsletterTitle': 'Abonohuni në emailin tonë',
  'footer.newsletterDesc': 'Merr lajme dhe oferta nga Fletaime.',
  'footer.emailPlaceholder': 'Email adresa',
  'footer.subscribe': 'Abonohu',
  'footer.copyright': '© 2026 Fletaime, Të gjitha të drejtat e rezervuara.',

  // Kategoritë (row titles + card labels; CSS i vë lowercase te kartat)
  'cat.travel': 'Travel Book',
  'cat.wedding': 'Love Book',
  'cat.baby': 'Baby Book',
  'cat.kitchen': 'Ditari i Kuzhinës',
  'cat.agenda': 'Agjenda 2026',
  'cat.kids': 'Kids Book',
  'cat.frame': 'Kornizë Muri',
  'cat.all': 'Të Gjitha Produktet',

  // Karta e produktit
  'card.new': 'e re',
  'card.orderNow': 'Porosit Tani',
  'card.addWish': 'Shto te të preferuarat',
  'card.removeWish': 'Hiq nga të preferuarat',

  // Home
  'home.heroSubtitle': 'libra të personalizuar që momentet tuaja i kthejnë në diçka reale',
  'home.orderNow': 'Porosit Tani',
  'home.rowPrev': 'Prapa',
  'home.rowNext': 'Para',
  'home.seeAllModels': 'Shiko të gjitha modelet →',
  'home.brandTitle': 'njihu me markën',
  'home.brandSub': 'historia pas historive tuaja',
  'home.story1Title': 'momente që mbesin',
  'home.story1Text': 'Fletaime i sjell kujtimet tuaja më të dashura në jetë përmes fotolibrave të punuar me kujdes, që mund t\'i mbani në duar përgjithmonë.',
  'home.story2Title': 'krijuar për t\'u dashur',
  'home.story2Text': 'Të krijuar për t\'u shfletuar shpesh dhe për t\'u mbajtur në vend të dukshëm — jo për t\'u harruar në një sirtar.',
  'home.story3Title': 'historia jote, mënyra jote',
  'home.story3Text': 'Me vegla të thjeshta dhe personalizim të plotë, Fletaime e vë krijimtarinë në duart tuaja — çdo kujtim bëhet diçka personale.',
  'home.story4Title': 'lidhje që na bashkojnë',
  'home.story4Text': 'Përtej ruajtjes së kujtimeve, festojmë lidhjet që ato krijojnë mes njerëzve, vendeve dhe momenteve.',
  'home.testimonialsTitle': 'Çka thonë klientët',
  'home.galleryTitle': 'fletaime + ju',
  'home.gallerySub': 'krijuar nga ju, të dashura për ne',
  'home.gallerySocial': 'na gjeni në rrjetet sociale',
  'home.helpTitle': 'Keni nevojë për ndihmë?',
  'home.helpDesc': 'Na shkruani në WhatsApp ose email — ekipi ynë përgjigjet shpejt.',

  // Katalogu (/photobooks)
  'catalog.bestsellers': 'Më të Shitura',
  'catalog.albums': 'Albumet',
  'catalog.loading': 'Duke ngarkuar produktet...',
  'catalog.noBestsellers': 'Ende s\'ka produkte të shënuara si "Më të Shitura".',
  'catalog.options': 'Opsionet',
  'catalog.searchPlaceholder': 'Kërko',
  'catalog.selectedCount': 'Produkte të Zgjedhura:',
  'catalog.sortDefault': 'Radhitja e zakonshme',
  'catalog.sortPriceAsc': 'Çmimi: nga i ulëti',
  'catalog.sortPriceDesc': 'Çmimi: nga i larti',
  'catalog.sortName': 'Emri (A-Z)',
  'catalog.noResults': 'Nuk u gjet asnjë produkt për këtë filtër.',

  // Shporta / Të preferuarat
  'shoplist.cartTitle': 'Shporta Ime',
  'shoplist.cartEmpty': 'Shporta jote është bosh.',
  'shoplist.viewProducts': 'Shiko Produktet',
  'shoplist.continueOrder': 'Vazhdo Porosinë',
  'shoplist.remove': 'Hiq',
  'shoplist.total': 'Totali:',
  'shoplist.wishTitle': 'Të Preferuarat',
  'shoplist.wishEmpty': 'Nuk ke asnjë produkt të preferuar ende.',
  'card.view': 'Shiko Produktin',

  // Faqja e produktit
  'product.loading': 'Produkti duke u gjetur!',
  'product.features': 'Karakteristikat:',
  'product.totalPrice': 'Çmimi Total:',
  'product.inCart': '✓ Në Shportë',
  'product.addToCart': 'Shto në Shportë',
  'product.choosePhotos': 'Zgjidhni numrin e fotove',
  'pageOption.50to75': '50 deri 75 Foto',
  'pageOption.75to150': '75 deri 150 Foto',
  'product.kitchenNote': 'Për idenë e personalizimit na shkruani në koment tek formulari',
  'product.order': 'Porosit',
  'product.designOnline': 'Dizajno Librin Online',
  'product.security': 'Siguri 100% – të dhënat tuaja janë të mbrojtura.',
  'product.tryFramePhoto': 'Provoni Foton Tuaj në Kornizë',
  'product.uploadFramePhoto': 'Ngarko Foton në Kornizë',
  'product.frameHint': 'Ngarko një foto për ta parë se si duket në kornizë',
  'product.uploadPhoto': 'Ngarko Foton',
  'product.kidsHint': 'Ngarko 1 foto për Kids Book tuaj',
  'product.uploadedPhotos': 'Fotot e Ngarkuara ({n})',
  'product.customizeTitle': 'Personalizoni Librin Tuaj',
  'product.seeOurProducts': 'Shiko Produktet Tona',
  'product.seeDetails': 'SHIKO DETAJET',
  'product.promoPrice': 'Çmim promocional',
  'product.alert.rawFormat': 'Foto "{name}" është në format RAW/TIFF të pa mbështetur.\n\nJu lutem eksportojeni si JPG dhe provoni përsëri.',
  'product.alert.notPhotos': 'Disa file nuk janë foto.\n\nFoto të pavlefshme: {names}\n\nJu lutem ngarkoni vetëm foto.',
  'product.alert.maxReached': 'Keni arritur limitin maksimal prej {max} fotosh për pakën e zgjedhur ({label}).\n\nNëse dëshironi të ngarkoni më shumë foto, zgjidhni pakën tjetër.',
  'product.alert.remainingOnly': 'Mund të ngarkoni vetëm {remaining} foto të tjera.\n\nKeni zgjedhur pakën: {label} (max {max} foto)',
  'product.alert.onlyPhotos': 'Ju lutem ngarkoni vetëm foto.',

  // Dizajnuesi i fotolibrit
  'designer.defaultTitle': 'Photo Book',
  'designer.openDrawer': 'Hap panelin',
  'designer.closeDrawer': 'Mbyll panelin',
  'designer.pageLimits': 'Limitet e Faqeve',
  'designer.uploadMore': 'Ngarko më shumë foto ({n}/5 min) për të filluar.',
  'designer.uploadedCount': 'Keni {count} / {max} foto të ngarkuara.',
  'designer.maxLine': 'Max: {maxPhotos} foto | {maxPages} faqe',
  'designer.statPages': 'Faqe',
  'designer.statPhotosInPages': 'Foto në faqe',
  'designer.statUploaded': 'Ngarkuar',
  'designer.processing': 'Duke procesuar...',
  'designer.continueOrder': 'Vazhdo me Porosinë',
  'designer.previewBtn': 'Shiko si Libër',
  'preview.title': 'Pamja e Librit',
  'preview.editBtn': 'Vazhdo Redaktimin',
  'preview.prev': 'Faqja e mëparshme',
  'preview.next': 'Faqja tjetër',
  'preview.pageCounter': 'Faqja {current} / {total}',
  'designer.minPhotosWarning': 'Ngarko së paku 5 foto për të vazhduar',
  'designer.helpTitle': 'Udhëzime',
  'designer.customizeCover': 'Personalizo kopertinën',
  'designer.help1': 'Ngarko fotot duke klikuar "+ Shto Foto"',
  'designer.help2': 'Kliko në një slot bosh për të ngarkuar foto direkt',
  'designer.help3': 'Zgjidh layout-e të ndryshme për faqet',
  'designer.help4': 'Kur të përfundosh, kliko "Vazhdo me Porosinë"',
  'designer.preparing': 'Duke përgatitur...',
  'designer.pageWord': 'faqe',
  'designer.alert.noPhotosInPages': 'Ju lutem shtoni së paku një foto në faqe para se të vazhdoni me porosinë.',
  'designer.alert.unplaced': '{count} foto janë ngarkuar por NUK janë vendosur në asnjë faqe - nuk do të përfshihen në librin e printuar:\n\n{names}\n\nJu lutem vendosini këto foto në një faqe (ose hiqini nga biblioteka nëse nuk i doni) para se të vazhdoni.',
  'designer.alert.genericError': 'Ndodhi një gabim: {message}',

  // Editori i kopertinës
  'cover.zoomIn': 'Zmadho',
  'cover.zoomOut': 'Zvogëlo',
  'cover.rotate': 'Rrotullo',
  'cover.reset': 'Reset',
  'cover.delete': 'Fshi',
  'cover.uploadPhoto': 'Ngarko foton',
  'cover.textAndColors': 'Teksti & Ngjyrat',
  'cover.background': 'Sfondi',
  'cover.titleColor': 'Ngjyra e titullit',
  'cover.yearColor': 'Ngjyra e vitit',
  'cover.urlColor': 'Ngjyra e URL-së (mbrapa)',
  'cover.font': 'Fonti',
  'cover.titleSize': 'Madhesia e titullit:',
  'cover.yearSize': 'Madhesia e vitit:',
  'cover.titleLabel': 'Titulli',
  'cover.titlePlaceholder': 'p.sh. BARCELONA',
  'cover.yearLabel': 'Viti',
  'cover.spineTitleLabel': 'Titulli i shpinës (sipër)',
  'cover.spineTitlePlaceholder': 'p.sh. Vendi',
  'cover.spineDateLabel': 'Data e shpinës (poshtë)',
  'cover.spineDatePlaceholder': 'p.sh. 2026',
  'cover.spineColor': 'Ngjyra e tekstit të shpinës',
  'cover.introTitle': 'Redakto kopertinën si të duash',
  'cover.introText': 'Mund të ndryshosh titullin, foton dhe ngjyrat e kopertinës. Tani ke edhe një shirit anash (shpinë) me tekst të editueshëm — ndrysho "Vendi" dhe "Data" siç dëshiron.',
  'cover.introClose': 'E kuptova',
  'cover.spineNote': 'Ky tekst ruhet edhe në produktin final, si faqe e veçantë e shpinës.',
  'cover.layoutTitle': 'Layouti i Kopertines',
  'cover.back': 'Mbrapa',
  'cover.front': 'Para',
  'cover.layout1Photo': '1 Foto',
  'cover.layout4Photo': '4 Foto',
  'cover.layoutFullPage': 'Full Faqe',
  'cover.layoutNoPhoto': 'Pa Foto',
  'cover.tabText': 'Tekst',
  'cover.tabLayout': 'Layout',
  'cover.tabStickers': 'Stickers',
  'cover.stickersTitle': 'Stickers',
  'cover.stickersLoading': 'Duke ngarkuar...',
  'cover.stickersEmpty': 'Nuk ka stickers në këtë kategori.',
  'cover.previewNote': '33 × 48 cm · Tërhiq tekstin për ta lëvizur',

  // Emrat e layout-eve të faqeve
  'pagesLayout.single': 'Një foto (Full Page)',
  'pagesLayout.two-horizontal': 'Dy foto horizontale',
  'pagesLayout.three-top': 'Tre foto (1 lart, 2 poshtë)',
  'pagesLayout.four-grid': 'Katër foto (grid)',
  'pagesLayout.collage': 'Kolazh (5 foto)',

  // Menaxheri i faqeve (dizajnuesi)
  'pages.pageNumber': 'Faqja {n}',
  'pages.pageRangeNumber': 'Faqja {a}-{b}',
  'pages.uploadSlot': 'Ngarko foto',
  'pages.myPhotos': 'Fotot e Mia',
  'pages.loading': 'Duke ngarkuar...',
  'pages.addPhotos': '+ Shto Foto',
  'pages.addFromPhone': 'Shto nga Telefoni',
  'pages.pairingTitle': 'Shto foto nga telefoni',
  'pages.pairingSubtitle': 'Skano kodin QR ose hap linkun në telefon, zgjidh fotot dhe ato do të shfaqen automatikisht këtu.',
  'pages.copy': 'Kopjo',
  'pages.copied': 'U kopjua ✓',
  'pages.pairingAdded': '✓ {count} foto u shtuan nga telefoni',
  'pages.pairingWaiting': 'Në pritje të fotove nga telefoni...',
  'pages.close': 'Mbyll',
  'pages.maxPhotosShort': 'Max {max} foto',
  'pages.aiGeneratingTitle': 'Duke Gjeneruar me AI',
  'pages.aiWarningStrong': 'AI mund të gabojë',
  'pages.aiWarningRest': ', Po analizojmë fotot dhe po krijojmë faqet',
  'pages.bgLabel': 'Sfond:',
  'pages.uploadMorePhotos': 'Ngarko më shumë foto ({n}/5 min)',
  'pages.photoStats': '{count} / {max} foto - max {maxPages} faqe',
  'pages.font': 'Font',
  'pages.fontSize': 'Madhësia',
  'pages.style': 'Stili',
  'pages.alignment': 'Rreshtimi',
  'pages.color': 'Ngjyra',
  'pages.applyAllPages': 'Apliko të gjitha faqet',
  'pages.deleteText': '🗑 Fshi tekstin',
  'pages.addPageTitle': 'Shto faqe të re',
  'pages.addPageLimitTitle': 'Keni arritur limitin ({max} faqe)',
  'pages.addPageBtn': '+ Shto Faqe ({count}/{max})',
  'pages.changeLayout': '🔲 Ndrysho Layout',
  'pages.addText': 'T Shto Tekst',
  'pages.deletePage': '🗑 Fshi Faqen',
  'pages.coverThumb': 'Kopertina',
  'pages.chooseLayout': 'Zgjidh Layout-in',
  'pages.alert.slotLimit': 'Keni arritur limitin maksimal të fotove për këtë produkt.',
  'pages.alert.maxForProduct': 'Keni arritur limitin maksimal prej {max} fotosh për këtë produkt.\n\nHiqni disa foto nga faqet/biblioteka për të shtuar foto të reja.',
  'pages.alert.limitSkipped': 'Keni arritur limitin prej {max} fotosh - mund të shtoni vetëm {remaining} foto të tjera.\n\nKëto foto NUK u shtuan:\n{names}',
  'pages.alert.loadError': 'Ndodhi një gabim gjatë ngarkimit të fotove.',
  'pages.alert.maxPhotosLimit': 'Keni arritur limitin maksimal prej {max} fotove për këtë produkt.',
  'pages.alert.remainingOnly': 'Mund të ngarkoni vetëm {remaining} foto të tjera. U ngarkuan {added} nga {total} fotot e zgjedhura.',
  'pages.alert.minAI': 'Ju lutem ngarkoni së paku 3 foto për të gjeneruar me AI.',
  'pages.alert.aiError': 'Ndodhi një gabim gjatë gjenerimit. Ju lutem provoni përsëri.',
  'pages.alert.maxPages': 'Keni arritur limitin maksimal të faqeve ({max}).',
  'pages.deletePhotoTitle': 'Fshij foton',
  'pages.moveSlot': 'Lëviz slotin',
  'pages.rotate90': 'Rrotullo djathtas',
  'pages.rotateLeft90': 'Rrotullo majtas',
  'pages.rotateFree': 'Zvarrit për të rrotulluar lirshëm',
  'pages.fitPhoto': 'Rikthe origjinalen',
  'pages.aiHintBefore': 'Ngarkoni fotot këtu dhe',
  'pages.aiHintAfter': 'do të krijojë automatikisht albumin tuaj.',
  'pages.aiGenerateBtn': 'Gjeneroni Rënditjen me AI',

  // Faqja e porosisë (OrderForm)
  'order.loadingOrder': 'Duke u ngarkuar...',
  'order.noData': 'Nuk ka të dhëna porosie',
  'order.backToStart': 'Kthehu në fillim',
  'order.beforeUnloadWarning': 'Ngarkimi i fotove është në progres. A jeni të sigurt që doni të dilni?',
  'order.validation.firstName': 'Emri është i detyrueshëm',
  'order.validation.lastName': 'Mbiemri është i detyrueshëm',
  'order.validation.country': 'Shteti është i detyrueshëm',
  'order.validation.city': 'Qyteti është i detyrueshëm',
  'order.validation.address': 'Adresa është e detyrueshme',
  'order.validation.phone': 'Numri i telefonit është i detyrueshëm',
  'order.validation.phoneInvalid': 'Numri i telefonit nuk është valid',
  'order.promo.applied': 'Kodi u aplikua! -{pct}% zbritje',
  'order.promo.invalid': 'Kodi promocional nuk është valid',
  'order.alert.uploadFailedSlots': '{count} foto nuk u ngarkua dot dhe do të mungonte në librin e printuar. Ju lutem rifreskoni faqen, kontrolloni faqet e fotolibrit dhe vendosini fotot përsëri para se të vazhdoni.',
  'order.error.initFailed': 'Gabim gjatë fillimit të porosisë (Status: {status}). {text}',
  'order.error.initFailedGeneric': 'Gabim gjatë fillimit të porosisë!',
  'order.error.noPhotosUploaded': 'Asnjë foto nuk u ngarkua me sukses. Ju lutem provoni përsëri me lidhje interneti më stabile (ose hapeni këtë faqe në Safari/Chrome në vend të Instagram/Facebook).',
  'order.alert.saveFailed': 'Gabim gjatë ruajtjes së porosisë!',
  'order.error.checkoutFailed': 'Gabim gjatë krijimit të pagesës online',
  'order.error.submitFailed': 'Gabim gjatë dërgimit të porosisë!',
  'order.error.timeout': 'Ngarkimi i fotove po merr shumë kohë.\n\nMund të jetë:\n- Lidhja e internetit është e ngadaltë\n- Serveri është i zënë\n\nProvo përsëri me lidhje interneti më stabile.',
  'order.error.connectionDropped': 'Lidhja me serverin u ndërpre gjatë dërgimit të porosisë ({message}).\n\nKjo zakonisht ndodh nga:\n- Lidhja e internetit u nda për një moment (WiFi/rrjeti celular)\n- Telefoni ka kaluar në sfond ose ekrani është kyçur gjatë ngarkimit\n\nProvo përsëri me lidhje interneti më stabile dhe mos e mbyll faqen derisa të përfundojë.',
  'order.uploadTitle': 'Qendroni këtu me ne',
  'order.uploadWarning': '3 deri 5 minuta sa të ngarkohen të gjitha fotot në porosi.',
  'order.manualSuccessTitle': 'Faleminderit për Porosinë!',
  'order.manualSuccessAllOk': 'Fotot tuaja u ngarkuan me sukses.',
  'order.manualSuccessPartial': '{done} nga {total} foto u ngarkuan me sukses.',
  'order.photoLinkReady': '📸 Linku i fotove tuaja është gati. Mund ta shikoni ose ta kopjoni për ta ruajtur.',
  'order.someFailedManual': '⚠️ {count} foto nuk u ngarkuan dot: {names}. Këto skedarë erdhën bosh nga telefoni juaj - shpesh ndodh me foto iCloud të pashkarkuara plotësisht, ose kur e hapni këtë faqe brenda Instagram/Facebook në vend të Safari/Chrome. Ju lutem provoni t\'i shtoni këto foto veçmas, ose na kontaktoni për ndihmë.',
  'order.viewPhotos': '📸 Shiko Fotot',
  'order.linkCopied': '✅ Linku u Kopjua!',
  'order.copyLink': '🔗 Kopjo Linkun',
  'order.backHome': 'Kthehu në Faqen Kryesore',
  'order.inAppWarningBefore': '⚠️ Po e hapni këtë faqe brenda {browser}. Për të shmangur probleme me ngarkimin e fotove, hapeni në Safari ose Chrome: prekni ⋮ ose ••• lart djathtas dhe zgjidhni',
  'order.inAppOpenBrowser': '"Hap në Browser"',
  'order.inAppWarningAfter': '("Open in Browser" / "Open in Safari").',
  'order.summaryTitle': 'Përmbledhja e Porosisë',
  'order.discountApplied': '-{pct}% zbritje aplikuar',
  'order.shippingLine': '{price}€ + {shipping}€ transport',
  'order.pagesCount': 'Numri i faqeve:',
  'order.photosInPages': 'Foto në faqe:',
  'order.photosCountUnit': '{n} foto',
  'order.photosUploaded': 'Foto të ngarkuara:',
  'order.photoBookDesigned': '📖 Photo Book i Dizajnuar',
  'order.photoBookDesignedDesc': 'Keni dizajnuar {pages} faqe me {photos} foto.',
  'order.pdfAutoNote': 'PDF-ja do të gjenerohet automatikisht kur dërgoni porosinë.',
  'order.shippingNote': '📦 Transport: Kosovë +2€ | Shqipëri +5€ | Maqedoni +5€',
  'order.yourPhotos': 'Fotot Tuaja:',
  'order.yourDataTitle': 'Të Dhënat Tuaja',
  'order.firstName': 'Emri *',
  'order.firstNamePlaceholder': 'Shkruani emrin tuaj',
  'order.lastName': 'Mbiemri *',
  'order.lastNamePlaceholder': 'Shkruani mbiemrin tuaj',
  'order.country': 'Shteti *',
  'order.countrySelect': '-- Zgjidhni shtetin --',
  'order.countryKosovo': '🇽🇰 Kosovë (+2€ transport)',
  'order.countryAlbania': '🇦🇱 Shqipëri (+5€ transport)',
  'order.countryMacedonia': '🇲🇰 Maqedoni e Veriut (+5€ transport)',
  'order.city': 'Qyteti *',
  'order.cityPlaceholder': 'Shkruani qytetin tuaj',
  'order.address': 'Adresa *',
  'order.addressPlaceholder': 'Shkruani adresën tuaj të plotë',
  'order.phone': 'Numri i Telefonit *',
  'order.comments': 'Koment / Përshkrim (Opsional)',
  'order.commentsPlaceholder': 'Shkruani ndonjë koment ose përshkrim për porosinë tuaj (opsionale)',
  'order.promoLabel': 'Kodi Promocional (Opsional)',
  'order.promoPlaceholder': 'Shkruani kodin promocional',
  'order.apply': 'Apliko',
  'order.paymentMethod': 'Mënyra e Pagesës',
  'order.payCash': 'Cash në Dorëzim',
  'order.payCashSub': 'Paguani kur t\'ju vijë porosia',
  'order.payOnline': 'Paguaj online',
  'order.payOnlineSub': 'Pagesë e shpejtë dhe e sigurt',
  'order.payOnlineDiscountBadge': '-{pct}%',
  'order.paymentSecurityNote': 'Pagesat online përpunohen në mënyrë të sigurt përmes Stripe.',
  'order.processingPhotoBook': '⏳ Duke procesuar Photo Book... Ju lutem prisni',
  'order.processingPhotos': '⏳ Duke ngarkuar fotot... Ju lutem prisni',
  'order.sendManual': '📤 Dërgo Porosinë',
  'order.continueToPay': 'Vazhdo te Pagesa',
  'order.sendWhatsApp': 'Dërgo Porosinë në WhatsApp',
  'order.generatingPdf': '⏳ Duke gjeneruar PDF me {pages} faqe... Mos mbylle faqen!',
  'order.uploadingPhotosCount': '⏳ Duke ngarkuar {n} foto... Mos mbylle faqen!',
  'order.noteManual': '* Duke klikuar butonin, fotot tuaja do të ngarkohen dhe do të merrni linkun për t\'i shikuar',
  'order.noteCard': '* Duke klikuar butonin, do të kaloni te faqja e sigurt e pagesës',
  'order.noteWhatsApp': '* Duke klikuar butonin, porosia juaj do të dërgohet në WhatsApp',
  'order.successTitle': 'Porosia u Dërgua me Sukses!',
  'order.successOpened': 'WhatsApp duhet të jetë hapur automatikisht.',
  'order.pdfSentLabel': 'Photo Book PDF:',
  'order.pdfSentDesc': 'PDF-ja me {pages} faqe u gjenerua dhe u dërgua me porosinë.',
  'order.remindSendLabel': 'Mos harroni:',
  'order.remindSendDesc': 'Dërgoni {n} fotot e zgjedhura në WhatsApp chat!',
  'order.someFailedBackup': '⚠️ {count} foto nuk u ruajtën si kopje rezervë në serverin tonë: {names}. Shpesh ndodh me foto iCloud të pashkarkuara plotësisht, ose kur e hapni këtë faqe brenda Instagram/Facebook. Sigurohuni t\'i dërgoni vetë këto foto në WhatsApp chat.',
  'order.ifNotOpened': 'Nëse WhatsApp nuk u hap, kliko butonin më poshtë:',
  'order.openWhatsAppManually': '📱 Hap WhatsApp Manualisht',

  // Mesazhi i porosisë në WhatsApp — gjenerohet në gjuhën e klientit
  'wa.title': '🎉 *POROSI E RE* 🎉',
  'wa.product': '📦 *Produkti:*',
  'wa.priceBefore': '💰 *Çmimi i Produktit (para zbritjes):*',
  'wa.promoCode': '🏷️ *Kodi Promocional:*',
  'wa.priceAfterDiscount': '💸 *Çmimi pas zbritjes:*',
  'wa.price': '💰 *Çmimi i Produktit:*',
  'wa.shipping': '🚚 *Transporti ({country}):*',
  'wa.totalPrice': '✅ *Çmimi Total:*',
  'wa.bookDetails': '📖 *Detajet e Librit:*',
  'wa.bookWith': '• Libër me:',
  'wa.pagesWord': 'faqe',
  'wa.photosInPage': '• Numri i fotos në faqe:',
  'wa.productDetails': '📦 *Detajet e Produktit:*',
  'wa.photosCount': '• Numri i fotos:',
  'wa.customerData': '👤 *Të dhënat e Klientit:*',
  'wa.name': '• Emri:',
  'wa.country': '• Shteti:',
  'wa.city': '• Qyteti:',
  'wa.address': '• Adresa:',
  'wa.phone': '• Telefoni:',
  'wa.comment': '• Komenti:',
  'wa.bookPagesZip': '📦 *Faqet e Librit (ZIP):*',
  'wa.downloadPages': 'Shkarko faqet e librit këtu:',
  'wa.customerPhotos': '📸 *Fotot e Klientit:*',
  'wa.seePhotos': 'Shiko fotot këtu:',
  'wa.waitingConfirm': '⏳ Jam në pritje të konfirmimit për porosinë.',
  'wa.orderDate': '*Data e Porosisë:*',

  // OrderSuccess (Stripe)
  'success.checking': 'Duke konfirmuar pagesën...',
  'success.confirmed': 'Pagesa u krye me sukses!',
  'success.thanks': 'Faleminderit për porosinë!',
  'success.confirmedDesc': 'Porosia #{id} u paguan dhe u regjistrua. Do t\'ju kontaktojmë së shpejti për detajet e dërgesës.',
  'success.pendingDesc': 'Porosia #{id} u dërgua. Sapo pagesa të konfirmohet plotësisht, do të njoftoheni.',
  'success.sendConfirmBtn': '📱 Dërgo Konfirmimin në WhatsApp',
  'success.backHome': 'Kthehu në Faqen Kryesore',
  'wa.success.title': '✅ *Pagesa u krye me sukses*',
  'wa.success.paidLine': 'Porosia #{id} u paguan online.',
  'wa.success.name': 'Emri:',
  'wa.success.product': 'Produkti:',
  'wa.success.price': 'Çmimi:',
  'wa.success.wantConfirm': 'Dua konfirmim për porosinë.',

  // OrderCancel (Stripe)
  'cancel.orderNotFound': 'Porosia nuk u gjet',
  'cancel.genericError': 'Gabim gjatë krijimit të pagesës',
  'cancel.retryError': 'Gabim gjatë provës së pagesës. Provoni përsëri.',
  'cancel.title': 'Pagesa u anulua',
  'cancel.desc': 'Porosia #{id} është ruajtur, por pagesa nuk u përfundua. Mund ta provoni përsëri, ose të na kontaktoni në WhatsApp për ta rregulluar me cash.',
  'cancel.retrying': '⏳ Duke hapur pagesën...',
  'cancel.retryBtn': '💳 Provo Përsëri',
  'cancel.contactBtn': '📱 Kontakto në WhatsApp',
  'wa.cancel.message': 'Përshëndetje, kam një porosi (#{id}) por pagesa online s\'më kaloi. A mund ta rregullojmë me cash?',

  // OrderImages
  'images.loading': 'Duke ngarkuar fotot...',
  'images.notFoundTitle': '❌ Porosia nuk u gjet!',
  'images.notFoundDesc': 'Linku mund të jetë i vjetër ose i pavlefshëm.',
  'images.pageTitle': '📸 Fotot e Porosisë',
  'images.back': '← Kthehu',
  'images.cardTitle': 'Fotot e Porosisë',
  'images.orderId': 'Order ID:',
  'images.photoCount': 'Numri i fotove:',
  'images.date': 'Data:',
  'images.downloadAll': '⬇️ Shkarko të gjitha fotot ({n})',
  'images.downloadHint': 'Ose kliko në çdo foto për ta shkarkuar individualisht',
  'images.download': '⬇️ Shkarko',
  'images.photoWord': 'Foto {n}',
  'images.noImages': 'Nuk ka foto të ngarkuara për këtë porosi.',
  'images.homeBtn': '🏠 Kthehu në Faqen Kryesore',

  // Faqet e politikave
  'policy.backLink': '← Kthehu në faqen kryesore',

  'policy.privacy.title': 'Politika e Privatësisë',
  'policy.privacy.subtitle': 'Fletaime - Mbrojtja e të dhënave tuaja',
  'policy.privacy.intro': 'Fletaime respekton dhe mbron privatësinë e çdo përdoruesi të platformës sonë. Kjo politikë shpjegon mënyrën se si ne mbledhim, përdorim dhe mbrojmë të dhënat dhe materialet që përdoruesit ngarkojnë në platformën tonë.',
  'policy.privacy.s1Title': 'Mbledhja e të Dhënave',
  'policy.privacy.s1Text': 'Gjatë përdorimit të platformës Fletaime, përdoruesit mund të ngarkojnë fotografi dhe të japin të dhëna bazë si emri, mbiemri dhe informacionet e nevojshme për realizimin e porosisë. Këto të dhëna përdoren vetëm për qëllimin e përpunimit dhe realizimit të porosisë së klientit.',
  'policy.privacy.s2Title': 'Siguria e Fotografive',
  'policy.privacy.s2Text': 'Ne garantojmë që të gjitha fotografitë e ngarkuara nga përdoruesit trajtohen me nivel të lartë sigurie dhe privatësie. Fotografitë përdoren vetëm për realizimin e albumit ose produktit të porositur dhe nuk përdoren për asnjë qëllim tjetër.',
  'policy.privacy.s2Guarantee': 'Fletaime garanton që:',
  'policy.privacy.s2Li1': 'Fotografitë nuk shpërndahen tek palë të treta.',
  'policy.privacy.s2Li2': 'Fotografitë nuk përdoren për marketing apo promovim pa lejen e klientit.',
  'policy.privacy.s2Li3': 'Ato ruhen në sisteme të sigurta gjatë procesit të përpunimit të porosisë.',
  'policy.privacy.s3Title': 'Fshirja e Fotografive',
  'policy.privacy.s3Text': 'Pas përfundimit të procesit të dizajnimit, prodhimit dhe dorëzimit të porosisë tek klienti, fotografitë e ngarkuara fshihen nga sistemet tona brenda një periudhe të arsyeshme teknike. Kjo bëhet për të garantuar privatësinë dhe sigurinë e plotë të materialeve të klientit.',
  'policy.privacy.s4Title': 'Mbrojtja e të Dhënave',
  'policy.privacy.s4Text': 'Fletaime vepron në përputhje me legjislacionin në fuqi në Republikën e Kosovës për mbrojtjen e të dhënave personale dhe merr masa teknike dhe organizative për të mbrojtur informacionin e përdoruesve nga qasja e paautorizuar, humbja ose keqpërdorimi.',

  'policy.return.title': 'Politika e Kthimeve',
  'policy.return.subtitle': 'Fletaime - Garancia dhe cilësia',
  'policy.return.intro': 'Fletaime është e përkushtuar të ofrojë produkte cilësore dhe të realizuara sipas kërkesave të klientëve. Çdo porosi kalon në disa faza kontrolli përpara se të dërgohet tek klienti.',
  'policy.return.s1Title': 'Kontrolli i Cilësisë',
  'policy.return.s1Text': 'Para dërgimit, çdo album ose produkt i porositur kontrollohet në detaje nga ekipi ynë për të siguruar që:',
  'policy.return.s1Li1': 'Dizajni është realizuar sipas kërkesave të klientit',
  'policy.return.s1Li2': 'Materialet dhe printimi janë në gjendje perfekte',
  'policy.return.s1Li3': 'Produkti është i përfunduar sipas standardeve tona të cilësisë',
  'policy.return.s1Note': 'Vetëm pas këtij kontrolli porosia dërgohet për transport.',
  'policy.return.s2Title': 'Dëmtimet gjatë Transportit',
  'policy.return.s2Text': 'Në disa raste, produkti mund të dëmtohet gjatë procesit të transportit nga kompania e dërgesave. Nëse klienti e pranon porosinë dhe vëren se ajo ka ardhur e dëmtuar, Fletaime ofron zëvendësim të produktit pa kosto shtesë.',
  'policy.return.s3Title': 'Gabimet në Dizajn ose Prodhim',
  'policy.return.s3Text': 'Klienti ka të drejtë për zëvendësim të porosisë në rastet kur:',
  'policy.return.s3Li1': 'Dizajni nuk është realizuar sipas kërkesave të klientit',
  'policy.return.s3Li2': 'Ekipi i dizajnit ka harruar të përfshijë elemente të kërkuara nga klienti',
  'policy.return.s3Li3': 'Ka gabime të dukshme nga procesi i prodhimit',
  'policy.return.s3Li4': 'Produkti final nuk përputhet me porosinë e konfirmuar',
  'policy.return.s3Note': 'Në këto raste, Fletaime merr përgjegjësi për rregullimin ose zëvendësimin e produktit.',
  'policy.return.s4Title': 'Rastet kur nuk pranohet kthimi',
  'policy.return.s4Text': 'Për shkak se produktet janë të personalizuara për secilin klient, kthimi nuk pranohet në rastet kur:',
  'policy.return.s4Li1': 'Klienti ndryshon mendim pas prodhimit të porosisë',
  'policy.return.s4Li2': 'Porosia është realizuar saktësisht sipas kërkesës së konfirmuar nga klienti',
  'policy.return.s4Li3': 'Nuk ka dëmtime fizike ose gabime nga ekipi i dizajnit apo prodhimit',

  // Mobile upload (QR pairing) page
  'mobileUpload.title': 'Shto foto nga telefoni',
  'mobileUpload.subtitle': 'Zgjidh fotot dhe do të shfaqen automatikisht në kompjuter.',
  'mobileUpload.addPhotos': 'Shto Foto',
  'mobileUpload.addMore': 'Shto Më Shumë',
  'mobileUpload.uploading': 'Duke ngarkuar {done}/{total}...',
  'mobileUpload.done': '{count} foto u ngarkuan me sukses!',
  'mobileUpload.doneHint': 'Kthehu tek kompjuteri - fotot janë shtuar tashmë.',
  'mobileUpload.error': 'Diçka shkoi keq. Provo përsëri.',
  // Faqja Rreth nesh
  'about.hero.title': 'Çdo kujtim meriton të ruhet përgjithmonë.',
  'about.hero.lead': 'Fletaime lindi nga një ide e thjeshtë, por me një kuptim të veçantë: t\'u japim kujtimeve tona një vend ku mund të ruhen, të preken dhe të përjetohen përsëri, pavarësisht se sa kohë kalon.',
  'about.story.eyebrow': 'Historia jonë',
  'about.story.title': 'Një ide e lindur në vitin 2021, e kthyer në realitet në vitin 2025.',
  'about.story.p1': 'Historia e Fletaime filloi në vitin 2021, me dëshirën për të krijuar diçka të veçantë që do t\'i ndihmonte njerëzit të ruanin momentet më të rëndësishme të jetës së tyre.',
  'about.story.p2': 'Por për ne, nuk mjaftonte thjesht të krijonim një album fotografik. Donim të zhvillonim një produkt që do të përmbushte pritshmëritë e klientëve tanë, duke i kushtuar rëndësi çdo detaji, nga ideja fillestare deri te përvoja përfundimtare.',
  'about.story.p3': 'Për këtë arsye, viteve në vijim iu përkushtuam zhvillimit të idesë, testimit dhe përmirësimit të konceptit, me synimin për të krijuar një produkt që do të na përfaqësonte denjësisht.',
  'about.story.p4': 'Në vitin 2025, kjo ide mori formë konkrete me lansimin e versionit të parë të albumit tonë. Ky ishte vetëm fillimi i rrugëtimit të Fletaime dhe i misionit tonë për t\'i kthyer fotografitë në kujtime që zgjasin.',
  'about.story.p5': 'Sot, vazhdojmë të punojmë për ta bërë çdo album më shumë sesa një koleksion fotografish: një histori personale që meriton të ruhet përgjithmonë.',
  'about.tl.2021.title': 'Ideja',
  'about.tl.2021.text': 'Lind dëshira për të ruajtur momentet më të rëndësishme.',
  'about.tl.dev.title': 'Zhvillimi',
  'about.tl.dev.text': 'Vite përkushtimi: testim dhe përmirësim i konceptit.',
  'about.tl.2025.title': 'Albumi i parë',
  'about.tl.2025.text': 'Ideja merr formë me lansimin e versionit të parë.',
  'about.tl.today.title': 'Sot',
  'about.tl.today.text': 'Çdo album, një histori personale për t\'u ruajtur.',
  'about.mission.eyebrow': 'Misioni ynë',
  'about.mission.title': 'Kujtimet më të çmuara, në një formë të veçantë dhe afatgjatë.',
  'about.mission.p1': 'Misioni ynë është t\'i ndihmojmë njerëzit të ruajnë kujtimet më të çmuara të jetës së tyre në një formë të veçantë, personale dhe afatgjatë.',
  'about.mission.p2': 'Dëshirojmë që çdo klient që zgjedh Fletaime të përjetojë një proces të lehtë e të këndshëm, nga krijimi i albumit deri te momenti kur e mban atë në duar. Për ne, suksesi nuk matet vetëm me një produkt të përfunduar, por me kënaqësinë e klientit dhe emocionin që ai përjeton kur rikthehet te kujtimet e tij.',
  'about.mission.p3': 'Çdo album që krijojmë përfaqëson një histori unike. Prandaj, synojmë që cilësia, kujdesi ndaj detajeve dhe kënaqësia e klientit të jenë gjithmonë në qendër të punës sonë.',
  'about.mission.quote': 'Ne nuk ruajmë vetëm fotografi. Ne ndihmojmë të ruhen historitë që kanë rëndësi.',
  'about.val.quality': 'Cilësia',
  'about.val.detail': 'Kujdesi ndaj detajeve',
  'about.val.satisfaction': 'Kënaqësia e klientit',
  'about.vision.eyebrow': 'Vizioni ynë',
  'about.vision.title': 'Kujtimet nuk njohin kufij.',
  'about.vision.p1': 'Vizioni ynë është që Fletaime të bëhet zgjedhja e njerëzve kudo në botë kur dëshirojnë t\'i kthejnë kujtimet e tyre në albume të veçanta.',
  'about.vision.p2': 'Besojmë se kujtimet nuk njohin kufij dhe se çdo njeri, pavarësisht vendit ku jeton, meriton mundësinë për t\'i ruajtur momentet më të rëndësishme të jetës së tij në një formë që mund ta mbajë pranë përgjithmonë.',
  'about.vision.p3': 'Prandaj, synimi ynë është të zgjerojmë shërbimet e Fletaime në sa më shumë shtete, duke u ofruar klientëve nga vende të ndryshme mundësinë për të krijuar albumet e tyre, me të njëjtin përkushtim ndaj cilësisë dhe përvojës së klientit.',
  'about.vision.ambition': 'Ambicia jonë është e qartë: nga një ide e lindur në vitin 2021, drejt një brendi që i bashkon kujtimet e njerëzve në mbarë botën.',
  'about.closing.title': 'Fletaime – Kujtimet tuaja, historia juaj.',
  'about.closing.cta': 'Krijo albumin tënd',

  // Faqja e kontaktit
  'contact.eyebrow': 'Kontakti',
  'contact.title': 'Na shkruani, jemi këtu për ju.',
  'contact.lead': 'Keni një pyetje, një ankesë apo një ide për ne? Na kontaktoni dhe do t\'ju përgjigjemi sa më shpejt.',
  'contact.whatsapp': 'WhatsApp',
  'contact.instagram': 'Instagram',
  'contact.email': 'Email',
  'contact.whatsappHint': 'Na shkruani direkt',
  'contact.instagramHint': 'Na ndiqni dhe na dërgoni mesazh',
  'contact.emailHint': 'Përgjigjemi sa më shpejt',
  'contact.form.title': 'Dërgo një mesazh',
  'contact.form.type': 'Çfarë dëshironi të dërgoni?',
  'contact.form.type.request': 'Kërkesë',
  'contact.form.type.complaint': 'Ankesë',
  'contact.form.type.suggestion': 'Sugjerim',
  'contact.form.name': 'Emri dhe mbiemri',
  'contact.form.email': 'Email adresa',
  'contact.form.phone': 'Numri i telefonit (opsionale)',
  'contact.form.message': 'Mesazhi juaj',
  'contact.form.send': 'Dërgo mesazhin',
  'contact.form.sending': 'Duke dërguar...',
  'contact.form.success': 'Faleminderit! Mesazhi u dërgua me sukses. Do t\'ju kontaktojmë së shpejti.',
  'contact.form.error': 'Diçka shkoi keq. Provoni përsëri ose na shkruani në WhatsApp.',
  'contact.form.tooMany': 'Keni dërguar shumë mesazhe. Provoni përsëri pas pak.',
};

export default sq;
